import { Icon } from '@iconify/react';
import { React } from 'react';
import searchFill from '@iconify/icons-eva/search-fill';
// material
import {
  Box,
  InputAdornment,
  Stack,
  Autocomplete,
  TextField,
} from '@mui/material';

import { useNavigate } from 'react-router-dom';


// ----------------------------------------------------------------------
const users = [
  { id: 1, name: 'Renato Santos' },
  { id: 2, name: 'Jefferson Felipe' },
  { id: 3, name: 'João Paiva' },
  { id: 4, name: 'Paula Silva' },
  { id: 5, name: 'Ana Sofia Vicente' },
  { id: 6, name: 'Paula Amorim' },
  { id: 7, name: 'Paulo Peixoto' },
  { id: 8, name: 'Paulo Lopes' },
  { id: 9, name: 'Ana Santos' },
  { id: 10, name: 'Sofia Alves' },
  { id: 11, name: 'Carolina Cardoso' },
  { id: 12, name: 'Marina Dourado' },
  { id: 13, name: 'Diogo Silva' },
  { id: 14, name: 'Cristiano Ronaldo' },
  { id: 15, name: 'João Félix' },
];

const DESKTOP_WIDTH = 250;
//const APPBAR_MOBILE = 64;

export default function Searchbar() {

  const navigate = useNavigate();

  const handleChange = (value) => { //(value)
    //navigate.push(`/utentes/${value.id}`);
    if (value!=null){
      //console.log(value.id)
      navigate(`/utentes/perfil`);
    }
  };

 
  const options = users.map((option) => {
    const firstLetter = option.name[0].toUpperCase();
    return {
      //id: item['users.id'],
      //text: `${item['users.name']}`,
      firstLetter: /[0-9]/.test(firstLetter) ? '0-9' : firstLetter,
      ...option, 
    };
  });

  return (
    <Stack>
      <Autocomplete
        freeSolo
        //disableClearable
        onChange={(event, value) => {
          handleChange(value);
        }}
        options={options.sort((a, b) => -b.firstLetter.localeCompare(a.firstLetter))}
        groupBy={(option) => option.firstLetter}
        getOptionLabel={(option) => option.name}
        sx={{ width: DESKTOP_WIDTH}}
        //getOptionLabel={(option) => option.name}
        renderInput={(params) => (
            <TextField
              {...params}
              //autoFocus
              label="Pesquisar Utente..."
              sx = {{margin: 0.8, fontSize: 1, fontWeight: 'medium' }}
              InputProps={{
                ...params.InputProps,
                type: 'search',
                endAdornment: (
                  <InputAdornment position="end">
                    {/*<Icon icon={searchFill} width={20} height={20} />*/}
                    <Box
                      component={Icon}
                      icon={searchFill}
                      sx={{ color: 'text.disabled', width: 20, height: 20, margin: 1 }}
                    />
                  </InputAdornment>
                ),
              }}
            />          
        )}
      />
    </Stack>
    
    );

  
}
